import React, { forwardRef } from 'react'
import cx from 'classnames'

const Spacer = forwardRef(({
  className,
  ...props
}, ref) => {
  const classes = cx(className, 'm-spacer')

  return (
    <div
      className={classes}
      ref={ref}
      {...props}
    />
  )
})

export default Spacer
